export default __webpack_public_path__ + "static/media/rigth-live-mobile.888942f3.svg";